import React from 'react';

import { Button, Tooltip } from 'antd';

import type ICoProducer from 'interfaces/ICoProducer';

const statusContentClass = 'flex cursor-help! items-center text-[0.775rem] font-medium uppercase text-[#192542]';

export const PartnerStatus = ({ cop }: { cop: ICoProducer }) => {
  if (cop.pending && cop.action !== 'remove') return null;
  let action = 'Ativo';
  if (cop.new || !cop.customer_id) action = 'Novo';
  if (!cop.new && cop.edited) action = 'Parceiro será modificado';
  if (cop.pending && cop.action === 'remove') action = 'Parceiro será removido';
  return (
    <Tooltip title={<PartnerStatusTip />} placement='top'>
      <Button type='text' className={statusContentClass}>
        <strong>{action}</strong>
      </Button>
    </Tooltip>
  );
};

export const ApprobationStatus = ({ cop }: { cop: ICoProducer }) => {
  return (
    <Tooltip title={<ApprobationStatusTip />} placement='top'>
      <Button type='text' className={statusContentClass}>
        <span
          className={`font-[450] [&.Aprovado]:text-[#009358] [&.Pendente]:text-[#37474F] [&.Reprovado]:text-[#dc3f53] ${cop.status}`}
        >
          {cop.status}
        </span>
      </Button>
    </Tooltip>
  );
};

const PartnerStatusTip = () => (
  <>
    <p>Status do parceiro</p>
    <p>Ativo: parceiro está ativo no produto</p>
    <p>Novo: novo parceiro que será adicionado a uma nova configuração de parceiros</p>
    <p>Modificado: parceiro será modificado na nova configuração</p>
    <p>Removido: parceiro será removido dos parceiros do produto na nova configuração</p>
  </>
);

const ApprobationStatusTip = () => (
  <>
    <p>Status de aprovação</p>
    <p>Pendente: aguardando moderação do parceiro</p>
    <p>Aprovado: parceiro aprovou modificação/remoção</p>
    <p>Reprovado: parceiro recusou modificação/remoção</p>
  </>
);
